export default __webpack_public_path__ + "static/media/home-icon.753c8f4a.webp";